import React from 'react';
const CsvDownloadButton = React.memo((props) => {
    return (React.createElement("a", { className: `hover:opacity-100 opacity-90 bg-haikan-matching-red px-3 py-1 text-sm font-medium leading-5 text-white text-center transition-colors duration-150 border border-transparent rounded-md disabled:opacity-50 active:opacity-70 focus:outline-none focus:shadow-outline-red min-w-min whitespace-nowrap max-h-8 block`, href: props.href, download: true }, "CSV\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9"));
});
export default CsvDownloadButton;
